import React, { useEffect, useState } from 'react';
import './css/DescreteWeekBox.css';

const getDayName = (date) => date.toLocaleDateString('en-US', { weekday: 'short' });
const getMMDD = (date) => date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit' });

const dayMap = ['S', 'M', 'T', 'W', 'R', 'F', 'Sa'];

const dayToScheduleKey = {
  'S': '1',
  'M': '2',
  'T': '3',
  'W': '4',
  'R': '5',
  'F': '6',
  'Sa': '7',
};

export default function DescreteWeekBox({ data, question, selectedDay }) {
  const [weekDates, setWeekDates] = useState([]);

  useEffect(() => {
    const current = new Date(data.startOfWeek);
    const first = current.getDate() - current.getDay();
    const week = [...Array(7)].map((_, i) => {
      const d = new Date(current);
      d.setDate(first + i);
      return d;
    });
    setWeekDates(week);
  }, [data.startOfWeek]);

  const isScheduled = (dayLetter) => {
    const scheduleKey = dayToScheduleKey[dayLetter];
    return question?.schedule?.[scheduleKey]?.length > 0;
  };

  const getStatus = (inputDate) => {
    const inputDateString = inputDate.toISOString().slice(0, 10); // "YYYY-MM-DD"
    const currentDayLetter = dayMap[inputDate.getDay()];
    const scheduled = isScheduled(currentDayLetter);
  
    if (!scheduled) return { type: "NotScheduled" };
  
    const record = data.answered.find(obj =>
      obj.timestamp.slice(0, 10) === inputDateString
    );
  
    if (!record) {
      const today = new Date();
      const isFutureDate = inputDate > today;
      return {
        type: isFutureDate ? "Waiting" : "Missing"
      };
    }
  
    const values = Array.isArray(record.value) ? record.value : [record.value];
    const isNotAnswered = values.some(v => v === -1 || v === "-1");
  
    return {
      type: isNotAnswered ? "NotAnswered" : "Answered",
      value: isNotAnswered ? "Not Answered" : values.join(', '),
      timestamp: record.timestamp
    };
  };  

  const getColor = (status) => {
    switch (status.type) {
      case "Answered": return '#6A9C89';       // green
      case "NotAnswered": return '#e74c3c';    // red
      case "Missing": return '#5D6D7E'; 
      case "NotScheduled": return '#000';      // black
      case "Waiting": return '#f39c12';        // orange
      default: return '#ccc';
    }
  };
  

  return (
    <div className="week-box-wrapper">
      <h5>{question.longUIquestion}</h5>
      <div className="week-box-grid">
        {weekDates.map((date, idx) => {
          const status = getStatus(date);
          const dayLetter = dayMap[date.getDay()];
          const isOtherDayFaded = selectedDay !== '' && selectedDay !== dayLetter;
          const backgroundColor = getColor(status);
          const opacity = isOtherDayFaded ? 0.5 : 1;

          return (
            <div
              key={idx}
              className="day-box"
              style={{ backgroundColor, opacity }}
            >
              <div className="day-label">
                {getMMDD(date)} {getDayName(date)}
              </div>
              <div style={{ fontSize: '12px', marginTop: '4px' }}>
  {
    status.type === "Answered" ? status.value :
    status.type === "NotAnswered" ? "Not Answered" :
    status.type === "Missing" ? "Missing" :
    status.type === "Waiting" ? "Waiting for response 🕒" :
    "Not Scheduled"
  }
</div>
              {status.timestamp && (
                <div style={{ fontSize: '10px' }}>{status.timestamp}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
